import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-professional-ranking',
    templateUrl: './professional-ranking.component.html',
    styleUrls: ['./professional-ranking.component.scss'],
})
export class ProfessionalRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Profissional
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_PROFESSIONAL;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_PROFESSIONAL;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
